var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 75 75",
    style: {
      enableBackground: "new 0 0 75 75"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#139448;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.7,23.2H24.9c-2.2,0-4-1.8-4-4l0,0c0-2.2,1.8-4,4-4h45.9c2.2,0,4,1.8,4,4l0,0 C74.7,21.4,72.9,23.2,70.7,23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.7,42.9H24.9c-2.2,0-4-1.8-4-4l0,0c0-2.2,1.8-4,4-4h45.9c2.2,0,4,1.8,4,4l0,0 C74.7,41.1,72.9,42.9,70.7,42.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.7,62.6H24.9c-2.2,0-4-1.8-4-4l0,0c0-2.2,1.8-4,4-4h45.9c2.2,0,4,1.8,4,4l0,0 C74.7,60.8,72.9,62.6,70.7,62.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.8,23.2H4.5c-2.2,0-4-1.8-4-4l0,0c0-2.2,1.8-4,4-4h6.3c2.2,0,4,1.8,4,4l0,0C14.9,21.4,13.1,23.2,10.8,23.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.8,42.9H4.5c-2.2,0-4-1.8-4-4l0,0c0-2.2,1.8-4,4-4h6.3c2.2,0,4,1.8,4,4l0,0C14.9,41.1,13.1,42.9,10.8,42.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.8,62.6H4.5c-2.2,0-4-1.8-4-4l0,0c0-2.2,1.8-4,4-4h6.3c2.2,0,4,1.8,4,4l0,0C14.9,60.8,13.1,62.6,10.8,62.6z "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.34b06e02c80c9ec9e36f22c709fc38cc.svg";
export { ForwardRef as ReactComponent };